import { NgModule } from '@angular/core';
import { RouterModule, Routes, UrlSegment } from '@angular/router';
import { SharedLayoutComponent } from './shared-layout.component';

import { PARAMS } from '../../../_configs/params';
import { TendersResolver } from 'src/app/_utils/_resolvers/main-data.resolver';

const routes: Routes = [
	{
		path: '',
		component: SharedLayoutComponent,
		children: [
			{
				path: 'interested-plan',
				redirectTo: '', // Redirect to homepage
				pathMatch: 'full'
			},
			{
				path: '',
				loadChildren: () => import('./../../tenders/_components/tenders/main-tenders.module').then(m => m.MainTendersModule)
			},
			{
				path: 'state/:id/:third',
				loadChildren: () => import('./../../tender-listing/tenders-list.module').then(m => m.TendersListModule)
			},
			{
				path: 'keywords/:id/:third',
				loadChildren: () => import('./../../tender-listing/tenders-list.module').then(m => m.TendersListModule)
			},
			{
				path: 'authority/:id/:third',
				loadChildren: () => import('./../../tender-listing/tenders-list.module').then(m => m.TendersListModule)
			},
			{
				path: 'authority/:id/:second/:third',
				loadChildren: () => import('./../../tender-listing/tenders-list.module').then(m => m.TendersListModule)
			},
			{
				path: 'category/:id/:third',
				loadChildren: () => import('./../../tender-listing/tenders-list.module').then(m => m.TendersListModule)
			},
			{
				path: 'city/:id/:second/:third',
				loadChildren: () => import('./../../tender-listing/tenders-list.module').then(m => m.TendersListModule)
			},
			{
				path: 'procurement/:id/:third',
				loadChildren: () => import('./../../tender-listing/tenders-list.module').then(m => m.TendersListModule)
			},
			{
				path: 'all-tenders/:id/:third',
				loadChildren: () => import('./../../tender-listing/tenders-list.module').then(m => m.TendersListModule)
			},
			{
				path: 'all-tenders/:id/:second/:third',
				loadChildren: () => import('./../../tender-listing/tenders-list.module').then(m => m.TendersListModule)
			},
			{
				path: 'all-tenders/:third',
				loadChildren: () => import('./../../tender-listing/tenders-list.module').then(m => m.TendersListModule)
			},

			// Blog Page
			{
				path: 'blogs',
				loadChildren: () => import('../../blog/blog-routing.module').then(m => m.BlogRoutingModule)
			},

			// Details Page
			{
				matcher: tenderDetailsMatch,
				loadChildren: () => import('../../tender-details/tender-details.module').then(m => m.TenderDetailsModule)
			}
		],
		resolve: { tendersResolver: TendersResolver }
	},
];

export function tenderDetailsMatch(url: UrlSegment[]): any {
	if (url.length > 3 && url[0].toString() === PARAMS.STATIC_PARAMS.DETAILS) {
		return { consumed: url, posParams: { stateId: url[1], authorityId: url[2], tenderId: url[3] } };
	}
	return null;
}

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class SharedLayoutRoutingModule { }